module.exports = __webpack_public_path__ + "media/snacks/lots-of-treats-86dfb095.svg";